function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  stroke: "#000",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.032 3.791h13.844M3.109 2.234a.173.173 0 100 .346.173.173 0 000-.346m1.384 0a.173.173 0 100 .346.173.173 0 000-.346m1.384 0a.173.173 0 100 .346.173.173 0 000-.346"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.57 12.095H2.416c-.764 0-1.384-.62-1.384-1.385V2.404c0-.765.62-1.384 1.384-1.384h11.075c.765 0 1.385.62 1.385 1.384v5.191"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.646 12.79a4.153 4.153 0 108.306 0 4.153 4.153 0 00-8.306 0h0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.184 12.79h-1.385v-2.076"
}));

function SvgTimeframe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18
  }, props), _ref);
}

export default SvgTimeframe;